import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { StatisticEntityName } from './StatisticEntityName'
import { DateTime } from 'luxon'
import { useStatisticParams } from './useStatisticParams'
import AddchartIcon from '@mui/icons-material/Addchart'
import RouteContainer from 'src/components/App/RouteContainer'
import { FormControl, IconButton, InputLabel, Tooltip } from '@mui/material'
import styled from 'styled-components'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

const WEEKLY = { from: DateTime.now().startOf('week').toJSDate(), to: DateTime.now().endOf('week').toJSDate() }
const MONTHLY = { from: DateTime.now().startOf('month').toJSDate(), to: DateTime.now().endOf('month').toJSDate() }
const LIFETIME = { from: DateTime.fromObject({ year: 2015, month: 1, day: 1 }).toJSDate(), to: DateTime.now().endOf('month').toJSDate() }

const StyledDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`
const SearchDashboardComponent = React.lazy(() => loadComponent('statistic', 'SearchResultDashboard'))

export function SearchDashboard() {
    const navigate = useNavigate()
    const [selectValue, setSelectValue] = useState('Lebenslang')

    const [config, setConfig] = useStatisticParams()
    const { type, _id } = useParams()

    const isConfigInvalid = Object.values(config).some((value) => value === null || value === undefined)

    const onMoreDetailsClick = () => {
        navigate(`/statistic/${type}/${_id}`)
    }

    const onPeriodSelect = (event: SelectChangeEvent) => {
        const value = event.target.value
        setSelectValue(value)
        switch (value) {
            case 'Wöchentlich':
                setConfig({
                    ...config,
                    ...WEEKLY,
                })
                break
            case 'Monatlich':
                setConfig({
                    ...config,
                    ...MONTHLY,
                })
                break

            case 'Lebenslang':
                setConfig({
                    ...config,
                    ...LIFETIME,
                })
                break
        }
    }

    useEffect(() => {
        if (isConfigInvalid) {
            setConfig({
                from: DateTime.fromObject({ year: 2015, month: 1, day: 1 }).toJSDate(),
                to: DateTime.now().endOf('month').toJSDate(),
                chart: 'bar',
                breakdown: '',
                cumulation: 'training_progress',
                context: [],
            })
        }
    }, [isConfigInvalid, setConfig])

    return (
        <RouteContainer>
            {type && _id && !isConfigInvalid && (
                <>
                    <StyledDiv>
                        <StatisticEntityName />
                        <StyledDiv>
                            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                <InputLabel id="period-select">Zeitraum</InputLabel>
                                <Select
                                    labelId="period-select"
                                    id="period-select"
                                    value={selectValue}
                                    label="Zeitraum"
                                    onChange={onPeriodSelect}>
                                    <MenuItem value="Wöchentlich">Wöchentlich</MenuItem>
                                    <MenuItem value="Monatlich">Monatlich</MenuItem>
                                    <MenuItem value="Lebenslang">Lebenslang</MenuItem>
                                </Select>
                            </FormControl>
                            <Tooltip title="Mehr Details">
                                <IconButton onClick={onMoreDetailsClick}>
                                    <AddchartIcon fontSize="large" />
                                </IconButton>
                            </Tooltip>
                        </StyledDiv>
                    </StyledDiv>
                    <SearchDashboardComponent type={type} id={_id} config={config} />
                </>
            )}
        </RouteContainer>
    )
}
